import { Box, Button, Flex, Typography } from '@project44/manifest-ds';
import { Modal } from '@project44/material-ui-deprecated';
import { useTranslation } from '@project44/translations-utils';

interface DialogModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  isOpen?: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
}

function DialogModal({
  confirmLabel,
  description,
  isOpen = false,
  onCancel,
  onConfirm,
  title,
}: DialogModalProps) {
  const { t } = useTranslation();
  const cancel = t('common.cancel');
  const confirm = confirmLabel || t('common.confirm');

  return (
    <Modal
      data-testid="dialog-modal"
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      disablePortal
    >
      <Box
        css={{
          bgColor: 'white',
          left: 0,
          margin: '0 auto',
          position: 'absolute',
          right: 0,
          top: '25%',
          width: 'calc(100% - 40px)',
        }}
      >
        <Flex
          orientation="vertical"
          gap="medium"
          css={{
            borderBottom: '1px solid $border-primary',
            padding: '$medium',
          }}
        >
          <Typography id="confirmation-modal-title" variant="title">
            {title}
          </Typography>
          <Typography id="confirmation-modal-description" variant="body">
            {description}
          </Typography>
        </Flex>
        <Flex
          align="center"
          justify="end"
          gap="medium"
          css={{ padding: '$medium' }}
        >
          <Button
            aria-label={cancel}
            variant="tertiary"
            size="small"
            onPress={onCancel}
          >
            {cancel}
          </Button>
          <Button
            aria-label={confirm}
            variant="danger"
            size="small"
            onPress={onConfirm}
          >
            {confirm}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}

export default DialogModal;
